export default __webpack_public_path__ + "static/media/ic_serbia.93929b8f.svg";